
// components/Hero.tsx
import {
    Headline,
    Subheadline,
    Container,
    ContentWrapper,
    CTAGroup,
    CTAButton,
} from '@/components/ui'
import HeroInputCTA from './HeroInputCTA'
import { BUTTON_IDS } from '@/lib/constants'
import { APP_LOGIN_URL } from '@/lib/redirect-utils'
// const HeroVideo = dynamic(() => import('./HeroVideo'))


interface HeroHomepageProps {
    shouldShowVideo?: boolean,
    className?: string,
    title?: string,
    subtitle?: string
    bookDemoText?: string
}

const HeroHomepage = ({
    shouldShowVideo = true,
    className = " gradient-bg-12",
    title = "Get Your Projects Under Control",
    subtitle = "Stop the chaos. Our AI TaskWriter turns messy requirements into perfect project specifications",
    bookDemoText = "Book Demo"
}: HeroHomepageProps) => {
    return (

        <>
            <section className='py-0  hero mx-auto max-w-[1808px] sm:px-[1.5rem] px-3 ' >
                <div className="section_container w-full">
                    {/* Hero Content Container with specified padding */}
                    <Container className="md:max-h-full gradient-container gradient-bg-12" variant="hero">
                        {/* Headlines Container with specified gap */}
                        <ContentWrapper gap="lg" className="z-10 relative sm:px-0 px-2">
                            <Headline variant='hero'>{title}</Headline>
                            <Subheadline variant='hero' htmlContent={true}>
                                {subtitle}
                            </Subheadline>
                        </ContentWrapper>

                        {/* Main Screen Image */}
                        <div className="mainscreen-container-VWO-466  order-2 flex-grow flex sm:items-end items-start justify-center w-full relative">

                            <div className="mainscreen  object-contain relative top-7 h-fit sm:top-0 max-w-[95%] w-full lg:max-w-[70%] lg:w-[70%] sm:max-w-[95%] sm:w-full rounded-t-lg">
                                {/* <HeroVideo /> */}
                                <img vwo-el-id="260009890" src="/images/sections/hero_section.avif" alt="hero image" className="rounded-xl" />
                            </div>
                        </div>
                        <CTAGroup orientation="vertical" style={{ zIndex: 20 }}
                                className={`w-full  order-1 sm:w-auto px-4 sm:px-0 sm:relative  left-0 right-0 sm:bottom-auto sm:left-auto sm:right-auto mt-6 z-20`}>
                                <div className='flex items-center gap-4 flex-col sm:flex-row w-full'>
                                    <CTAButton
                                        id={BUTTON_IDS.GET_STARTED}
                                        href={APP_LOGIN_URL}
                                        variant="primary"
                                        size="hero"
                                        external
                                        className="w-full sm:w-auto "
                                    >
                                        Start Deep Work Mode
                                    </CTAButton>
                                    {/* <CTAButton
                                        id={BUTTON_IDS.GET_STARTED}
                                        href={APP_LOGIN_URL}
                                        variant="primary"
                                        size="hero"
                                        external
                                        className="w-full sm:w-auto VWO_670_v2"
                                    >
                                        Try Async-First Workflow
                                    </CTAButton>
                                    <CTAButton
                                        id={BUTTON_IDS.GET_STARTED}
                                        href={APP_LOGIN_URL}
                                        variant="primary"
                                        size="hero"
                                        external
                                        className="w-full sm:w-auto VWO_670_v3"
                                    >
                                        Ship 3x Faster
                                    </CTAButton> */}
                                    <CTAButton
                                        id='book-demo-button'
                                        href="https://calendly.com/hypertask/30min"
                                        variant="outline"
                                        size="hero"
                                        external
                                        className="w-full sm:w-auto bg-black border-white/50 border sm:border"
                                    >
                                        {bookDemoText}
                                    </CTAButton>
                                    {/* Reassurance Element */}
                                </div>
                                <p className="text-white font-semibold tracking-tighter text-base mb-1">
                                    🔥 Where focus meets collaboration.
                                </p>
                            </CTAGroup>
                        {/* <div
                            style={{ zIndex: 20 }}
                            className="w-full VWO_670 flex flex-col gap-4 px-2 sm:max-w-[600px] order-1   absolute sm:relative bottom-4 left-0 right-0 sm:bottom-auto sm:left-auto sm:right-auto sm:mt-6 z-20 flex justify-center"
                        >
                            <HeroInputCTA />
                            
                            <p className="text-white font-semibold tracking-tighter text-base mb-1">
                                🔥 Where focus meets collaboration.
                            </p>
                        </div> */}

                    </Container>
                </div>
            </section>

        </>
    )
}

export default HeroHomepage